import { MAIN_CONTENT_ID } from 'config/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';
import useProgrammaticFocus from 'hooks/useProgrammaticFocus';

const SkipLink: React.FC = () => {
  const { t } = useTranslation();

  const onSkiplinkClick = useProgrammaticFocus(document.getElementById(MAIN_CONTENT_ID));

  return (
    <div className="Skiplink">
      <a href={`#${MAIN_CONTENT_ID}`} onClick={() => onSkiplinkClick()}>
        {t('skiplink')}
      </a>
    </div>
  );
};

export default SkipLink;
